module.exports = __webpack_public_path__ + "assets/YT.4e655cf9.svg";